import { useEffect, useRef } from "react";
import ViolinPlot from "../components/Plotly";

/* eslint-disable jsx-a11y/anchor-is-valid */
export function Dropdown1({ itemName, selectedISPP, data, rankScore, plotError }) {
  if (selectedISPP !== itemName) {
    return (
      <div className='menu menu-sub menu-sub-dropdown w-250px w-md-300px' data-kt-menu='true' style={{
        minWidth: 'fit-content'
      }}
      >
        <div className='px-7 py-5'>
          <div className='fs-5 text-dark fw-bolder'>{selectedISPP}</div>
        </div>

        <div className='separator border-gray-200'></div>
        {plotError && <div> Error: {plotError} </div>}

      </div>
    )
  }
  return (
    <div className='menu menu-sub menu-sub-dropdown w-750px w-md-750px' data-kt-menu='true' style={{
      minWidth: 'fit-content'
    }}
    >
      <div className='px-7 py-5'>
        <div className='fs-5 text-dark fw-bolder'>{selectedISPP}</div>
      </div>

      <div className='separator border-gray-200'></div>
      {plotError && <div className="text-center py-2 text-danger"> {plotError} </div>}
      {!data && !plotError && <div className="d-flex justify-content-center py-2">
        <div className='spinner-border text-center' role='status'>
          <span className='visually-hidden'>Loading...</span>
        </div>
      </div>}
      {data && <ViolinPlot rankScore={isNaN(rankScore) ? 0 : rankScore} data={data} />}
    </div>
  )
}
